import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import { Footer as CoreFooter } from '@leshen/gatsby-theme-leshen'

import footerData from '../data/footerData'

function Footer({ disclaimers }) { 
  return (
    <CoreFooter
      logo={
        <StaticImage
          src="../images/logo.svg"
          alt="logo"
          placeholder="blurred"
        />
      }
      logoLink="/availability"
      navData={footerData}
      navigationTextColor="white"
      disclaimers={disclaimers}
      disclaimerTextColor="white"
      disclaimerBackgroundColor="primary"
      navigationBackgroundColor="primary"
    />
  )
}

export default Footer
